<template>
  <b-field
    :type="errorClasses"
    :class="errorClasses"
    :message="errorText"
    :label="label"
    class="form-field">
    <multiselect-field v-if="options"
                       id="job_title"
                       :options="options"
                       :value="value"
                       :taggable="false"
                       :multiple="false"
                       :iconField="true"
                       :close-on-select="true"
                       :clear-on-select="true"
                       :showOptionsList="true"
                       :showLabels="true"
                       :allow-empty="false"
                       :disabled="disabled"
                       :has-validation-error="!!errorText"
                       :big-input-font-size="true"
                       :select-label="selectLabel"
                       :selected-label="selectedLabel"
                       :placeholder="placeholder"
                       label="name"
                       deselect-label=""
                       track-by="slug"
                       @input="onInput">
      <template slot="multiselect-icon">
        <div class="tag-icon">
          <div v-if="isLoading" class="loader" width="16" height="16"></div>
          <svg-icon v-else name="position" width="16" height="16"></svg-icon>
        </div>
      </template>
    </multiselect-field>
  </b-field>
</template>

<script>

import 'top20common/distribution/icons/position';

import MultiselectField from 'top20common/components/MultiselectField';

export default {
  props: {
    errorText: String,
    label: String,
    options: Array,
    value: Object,
    isLoading: Boolean,
    placeholder: String,
    disabled: Boolean
  },
  computed: {
    errorClasses() {
      return this.errorText ? 'is-danger has-error' : '';
    },
    selectedLabel() {
      return this.$gettext('Selected');
    },
    selectLabel() {
      return this.$gettext('Press enter to select');
    }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    }
  },
  components: {MultiselectField}
};
</script>

<style lang="scss" scoped>
.tag-icon {
  /deep/ .svg-fill {
    fill: var(--gray);
  }
}
</style>
